import React, { useEffect, useState } from 'react'
import {  useNavigate } from 'react-router-dom';
import Icon from '../../components/tables/Icon';
import axios from 'axios';
import language from '../../variables/language';
import { DateTime } from  "luxon";
import ChatComponent from '../../components/websocket/ChatComponent';
import IconChat from '../../components/icons/IconChat';

export default function StagesMenu(props) {
   const navigate = useNavigate();
   const [chat , setChat ] = useState(false);
   const [stages, setStages] = useState(props.stages);


   useEffect(() => {

      
        axios.get('/api/stages?stageType='+props.chosenStageType, { withCredentials: true })
         .then(response => {
            setStages([]);
            setStages(response.data);
         })
         .catch(err => {
            console.log(err);
         });
   },[props.chosenStageType])


   const oncliHundler =(e)=> {
      e.stopPropagation();
      props.stateHundler('none',props.id);
   }

   const setStage = (e,id) => {
      e.stopPropagation();
      axios.put('/api/clients/'+props.id,
         JSON.stringify({stage:id}), {
            withCredentials: true,
            headers: {
               'Content-Type': 'application/json',
            },
      }).then(response => {
        props.onRefresh();
        props.stateHundler('none',props.id);
      })
      .catch(err => {
         navigate('/pipeline');
      
      console.log(err);
      });
   }
   const goToClient = (e) => {
      e.stopPropagation();
      navigate("/clients/"+props.id);
   }
   const onRefreshHundler = ()=>{

   }
      const chatTriger = (e) => {
         e.stopPropagation();
      if (chat) {
         setChat(false);
      } else {
         setChat(true);
      }
   }

   const setChosenStageType = (e, id) => {
      e.stopPropagation();
      props.setChosenStageType(id);
   }
  return (
    <div className='pipe-menu' onClick={oncliHundler}   >
      {
         chat ? (
            <ChatComponent
               clientId={props.id}
               closeCallback={() => setChat(false)}
            />
         ):
         (
            ''
         )
      }
      <div className='pipe-menu-header'>
         <div className='pipe-menu-header-info'>
            <h3 className='pipe-menu-client-name'>{props.client.firstName} {props.client.lastName}</h3>
            <p className='pipe-menu-client-date'>
               {language[language.lang]['dAdd']}: {DateTime.fromISO(props.client.dAdd, { setZone: true }).toFormat("dd.MM.yyyy")}
               {' · '}
               {language[language.lang]['time add']}: {DateTime.fromISO(props.client.dAdd, { setZone: true }).toFormat("HH:mm:ss")}
            </p>
         </div>
         <div className='pipe-menu-header-actions'>
            <div className='pipe-menu-icon-btn' onClick={goToClient} title={language[language.lang]['client']}>
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" width="16" height="16" fill="var(--lighttext-color)">
                  <path d="M480-400q33 0 56.5-23.5T560-480q0-33-23.5-56.5T480-560q-33 0-56.5 23.5T400-480q0 33 23.5 56.5T480-400ZM320-240h320v-23q0-24-13-44t-36-30q-26-11-53.5-17t-57.5-6q-30 0-57.5 6T369-337q-23 10-36 30t-13 44v23ZM720-80H240q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80Zm0-80v-446L526-800H240v640h480Zm-480 0v-640 640Z"/>
               </svg>
            </div>
            <div className='pipe-menu-icon-btn' onClick={chatTriger} title='chat'>
               <IconChat fillColor='icon-green' style={{width:16,height:16,margin:0}} ></IconChat>
            </div>
         </div>
      </div>

      <div className='menu-pipe-selector' >
         <div className='menu-stage-type-container scrooll'>
            {
               props.satgeTypes ? (
                  props.satgeTypes.map(item => (
                     <div key={item.id+'sd'} onClick={ (e) => setChosenStageType(e , item.id) } 

                     className={`card-selector-stage-type txt-c ${props.chosenStageType == item.id ? 'selected-type' :'' }`} >{item.name}</div>
                  ))
               ) : ('')
            }
             
         </div>
         {Array.isArray(stages) ? (
                  stages.map(item => (
                     <div key={item.id+'sd'+props.chosenStageType} onClick={ (e) => setStage(e, item.id) } style={{borderLeft:`3px solid ${item.color}`,boxShadow:` 0px 0px 3px ${item.color}`}} className='card-selector-stage txt-c' >{item.name}</div>
                  ))
               ) : (
                  <div>Empty list</div>
            )}
      </div>
    </div>
  )
}
